import { useDispatch, useSelector, useStore } from 'react-redux';
import type { getAppStateStore } from './getAppStateStore';

type AvaRootState = ReturnType<ReturnType<typeof getAppStateStore>['getState']>;
export type AvaAppStore = ReturnType<typeof getAppStateStore>;
type AvaAppDispatch = ReturnType<typeof getAppStateStore>['dispatch'];

export const useAppStateStore = useStore.withTypes<AvaAppStore>();
export const useAppStateDispatch = useDispatch.withTypes<AvaAppDispatch>();
export const useAppStateSelector = useSelector.withTypes<AvaRootState>();
